interface RecordButtonProps {
  isRecording: boolean;
  seconds: number;
  /** True once a clip has been captured this session (shows a "Clip" state). */
  captured: boolean;
  onClick: () => void;
}

/**
 * Android-style record circle: a white ring with a red inner dot (a pulsing red
 * square while recording). Shows the elapsed seconds while recording and a
 * "Clip" state once a clip has been captured. Rendering state lives in the
 * caller (`useClipRecorder`), so the caller can also stop the recorder when a
 * session ends.
 */
export function RecordButton({ isRecording, seconds, captured, onClick }: RecordButtonProps) {
  return (
    <div className="flex flex-col items-center gap-1.5">
      <span className="h-4 text-xs font-medium tabular-nums text-white/90">
        {isRecording ? `${seconds}s` : captured ? "Clip" : ""}
      </span>
      <button
        type="button"
        onClick={onClick}
        aria-label={isRecording ? "Stop recording clip" : "Record clip"}
        className="flex size-16 items-center justify-center rounded-full border-2 border-white/90 bg-black/30 shadow-[0_0_20px_rgba(255,255,255,0.2)] backdrop-blur-md transition-transform hover:scale-105 active:scale-95"
      >
        <span
          className={`size-7 rounded-full transition-all duration-200 ${
            isRecording
              ? "animate-pulse rounded-md bg-red-500"
              : captured
                ? "bg-emerald-400"
                : "bg-red-600"
          }`}
        />
      </button>
    </div>
  );
}
